import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("julssy_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail === "object" && typeof detail.msg === "string")
    return detail.msg;
  return err?.message || "Algo deu errado. Tente novamente.";
}

export const auth = {
  login: async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("julssy_admin_token", data.token);
    localStorage.setItem("julssy_admin_email", data.email);
    return data;
  },
  logout: () => {
    localStorage.removeItem("julssy_admin_token");
    localStorage.removeItem("julssy_admin_email");
  },
  me: async () => {
    const { data } = await api.get("/auth/me");
    return data;
  },
  getEmail: () => localStorage.getItem("julssy_admin_email"),
  getToken: () => localStorage.getItem("julssy_admin_token"),
};

export const leads = {
  create: async (payload) => {
    const { data } = await api.post("/leads", payload);
    return data;
  },
  list: async () => {
    const { data } = await api.get("/admin/leads");
    return data;
  },
  remove: async (id) => api.delete(`/admin/leads/${id}`),
  exportCsvUrl: () => `${API_BASE}/admin/leads/export.csv`,
};

export default api;
